var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogodark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 27.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#28348b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_127",
    "data-name": "Groupe 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    className: "cls-1",
    d: "M51.27,12.07a5.47,5.47,0,0,0-6-4.73,14.11,14.11,0,0,0-2.82.41c-.3.08-.5.11-.57-.29s-.19-.5.22-.71C47.38,4,54.51,6.63,55.38,12.86a40.15,40.15,0,0,1,.08,5.26c0,.95,0,1.91,0,2.86,0,.57-.18.75-.71.67-1.15-.16-2.35.33-3.47-.28-.09-.05-.28.06-.42.12-3.07,1.14-6.08.7-9.06-.34a5.77,5.77,0,0,1-2.31-1.48A4,4,0,0,1,39.44,14a4.14,4.14,0,0,1,.38-.35,10.39,10.39,0,0,1,5.69-2.07,11.8,11.8,0,0,1,5.62.59l.13.09A1.7,1.7,0,0,0,51.27,12.07Zm.23,4.8a11.37,11.37,0,0,1,0-1.43A1.22,1.22,0,0,0,50.58,14a7.48,7.48,0,0,0-6.06.16,2.78,2.78,0,0,0-1.78,2.73,2.81,2.81,0,0,0,1.78,2.64,7.63,7.63,0,0,0,5.8.26c.88-.29,1.37-.75,1.19-1.75a6.31,6.31,0,0,1,0-1.15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    className: "cls-1",
    d: "M128.93,14.47c-2,0-4,0-6,0-.7,0-.93.1-.73.88.85,3.39,3.37,5,7.11,4.43.56-.08,1.11-.21,1.66-.3.22,0,.59-.28.59.2s.39.77-.14,1a9.47,9.47,0,0,1-9.69-.42,8.09,8.09,0,0,1-3.65-8.15,8.38,8.38,0,0,1,6.72-6.92,8.92,8.92,0,0,1,10.86,6.42,5.61,5.61,0,0,1,.13.59c.38,2.25.38,2.25-1.88,2.25Zm-2-2.3h4.19c.24,0,.66.16.58-.38-.51-3.48-2.74-5.24-6-4.52-2.15.48-3,2.24-3.5,4.2-.14.54-.07.74.54.72,1.4,0,2.79,0,4.19,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    className: "cls-1",
    d: "M113.28,14.89c0-2.65,0-5.62,0-8.58,0-.81.22-1,1-1,2.1.06,2.1,0,2.1,2.07,0,4.29,0,8.57,0,12.86,0,.33.27.88-.26,1a1.45,1.45,0,0,1-1.5-.28c-1.11-1.16-2.25-2.29-3.4-3.42-2.46-2.41-4.94-4.8-7.43-7.22-.13.11,0,.4,0,.64,0,3.18,0,6.36,0,9.55,0,.62-.16.8-.79.79-2.24,0-2.24,0-2.24-2.2,0-4.29,0-8.57,0-12.85,0-.65.1-.88.84-.94a3.8,3.8,0,0,1,3.25,1.34C107.61,9.52,110.55,12.26,113.28,14.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    className: "cls-1",
    d: "M89,21.68c-2.76-.16-5.22-1-6.92-3.31A8.07,8.07,0,0,1,81.25,10C82.51,7.05,85,5.76,88.08,5.38a10.31,10.31,0,0,1,7.43,1.53c2.92,2,3.79,5,3.16,8.31s-3,5.38-6.28,6.19A11.56,11.56,0,0,1,89,21.68ZM84.41,13a8.45,8.45,0,0,0,.87,4.3,4.71,4.71,0,0,0,4.45,2.57,4.56,4.56,0,0,0,4.46-2.72,8.35,8.35,0,0,0-.12-7.57A5,5,0,0,0,87.2,7.68a5,5,0,0,0-1.35,1.11A6.72,6.72,0,0,0,84.41,13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    className: "cls-1",
    d: "M16.15.07c6.4-.56,11,2.57,14.48,7.42,3.23,4.49,2.44,10-1.56,14.16A21.05,21.05,0,0,1,20.44,27c-1.38.46-2.86.08-4.31.1,1.29-.61,2.58-1.16,3.8-1.89a16.3,16.3,0,0,0,6.57-6.62C28.76,14.15,27.83,9,24.18,5.2A21,21,0,0,0,16.87.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    className: "cls-1",
    d: "M55.92,21.47c2.24-2.4,4.3-4.66,6.43-6.86.53-.54.45-.86,0-1.37C60.27,10.81,58.22,8.35,56,5.72c1.54,0,2.88,0,4.23,0,.34,0,.46.34.65.56l4.36,5.17C66.65,10,68.14,8.58,69.37,7c1-1.32,2.22-1.42,3.75-1.19L67.32,12c-.85.91-.85.9,0,1.87q2.94,3.46,5.86,7c.13.16.24.32.48.62H69.51c-.36,0-.49-.31-.68-.52-1.41-1.65-2.83-3.3-4.2-5-.4-.5-.59-.45-1,0-1.38,1.52-2.83,3-4.18,4.52a2.4,2.4,0,0,1-2.37,1A7.74,7.74,0,0,0,55.92,21.47Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    className: "cls-1",
    d: "M15,21.67a16.4,16.4,0,0,1-4,1.38,1.65,1.65,0,0,1-.7,0,14.45,14.45,0,0,1-8.4-4.67,7.47,7.47,0,0,1-.1-9.82,14.46,14.46,0,0,1,8.53-4.8c.72-.16,3.21.65,4.38,1.34-.15.3-.45.2-.68.24a13.6,13.6,0,0,0-6.77,3C3.9,11.2,3.82,15.43,7.11,18.39a13,13,0,0,0,6.63,3.05Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    className: "cls-1",
    d: "M78.63,14.74c0,1.93,0,3.87,0,5.8,0,.6-.18.77-.76.74-.89-.06-2,.28-2.59-.16s-.18-1.67-.18-2.54c0-3.25,0-6.49,0-9.73,0-.62.17-.84.8-.79a14,14,0,0,0,2.05,0c.56,0,.72.16.71.7C78.61,10.76,78.63,12.75,78.63,14.74Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    className: "cls-1",
    d: "M15.36,14.44c1.64,0,3.27,0,4.91,0,.59,0,.69.17.59.72a5.21,5.21,0,0,1-4.44,4.06A5.67,5.67,0,0,1,10,15.77c-.4-1.24-.35-1.33.91-1.33Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    className: "cls-1",
    d: "M15.38,12.36c-1.58,0-3.16,0-4.74,0-.84,0-.92-.29-.76-1a5.32,5.32,0,0,1,4.48-3.82c2.91-.53,5.93,1.31,6.46,3.89.14.66.08.94-.71.91C18.53,12.32,17,12.36,15.38,12.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    className: "cls-1",
    d: "M76.87,5.5a4.28,4.28,0,0,0,.8,0c.91-.17,1,.33,1,1.06,0,.46-.23.54-.61.53-.66,0-1.31,0-2,0-1,0-1.13-.17-1-1.2,0-.33.18-.38.45-.38Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogodark);
export default __webpack_public_path__ + "static/media/logodark.4c0d65a56b398e08975796c986d511c8.svg";
export { ForwardRef as ReactComponent };